import { useAtomValue } from 'jotai'
import { messagesAtom } from '../store'
import { MessageBox } from './MessageBox'
import { MdClose } from 'react-icons/md'
import { remove } from '../lib/messages'

const MessagesContainer = () => {
  const messages = useAtomValue(messagesAtom)

  if (!messages.length) {
    return null
  }

  return (
    <div className="flex flex-col gap-2 fixed top-16 right-0 left-0 p-2 z-50 sm:p-4 sm:top-16 sm:right-0 sm:left-auto">
      {messages.map((m, i) => (
        <MessageBox
          key={`${m.content}${i}`}
          variant={m.variant}
          contentClassName="flex gap-4 items-center px-4"
          containerClassName="m-0"
        >
          {m.content}
          <button onClick={() => remove(m.id)}>
            <MdClose size={24} />
          </button>
        </MessageBox>
      ))}
    </div>
  )
}

export default MessagesContainer
